module.exports = __webpack_public_path__ + "img/plan-3-1.337f87e9.png";